import { Injectable } from '@angular/core';
// import { IsTenantAvailableInput } from 'src/app/SiteNotAvailable/IsTenantAvailableInput';
import { GlobalDataService } from './globalData.service';
import { RestService } from './rest.service';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LocalStoreService } from './local-store.service';
// import { VirtualKeyBoardService } from 'src/app/modules/point-of-sale/make-sales/make-sales-services/virtualKeyBoard.service';
import { TranslateService } from '@ngx-translate/core';
import { IsTenantAvailableInput } from 'src/app/SiteNoteAvailable/IsTenantAvailableInput';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  loadingIndicator: boolean = true;

constructor(
  public globalDataService:GlobalDataService,
  private restService: RestService,
  private store: LocalStoreService,
  // private virtualKeyBoardService:VirtualKeyBoardService,
  private translate: TranslateService) { }




public isTenantAvailableInput={} as IsTenantAvailableInput;

checkTenantAvailability(tenantName: string): Observable<boolean> {
  this.isTenantAvailableInput.tenancyName = tenantName;

  return this.restService.post(`${environment.urls.Is_Tenant_Available}`, this.isTenantAvailableInput).pipe(
    map((response: any) => {
      
      if (response.success && response.result.tenantId != null) {
        this.store.setItem("tenantName",tenantName);
        this.store.setItem("tenantId",response.result.tenantId);
        return true;
      } else {
        return false;
      }
    }),
    catchError(() => {
      return of(false);
    })
  );

}




}

